'use client';

import { preload } from 'react-dom';
import LoginScreen from 'screens/LoginScreen';
import NoSsr from '@ui/components/molecules/NoSsr/NoSsr';
import { heroImages } from '@ui/components/user/screens/LoginScreen/heroImages';
import { heroSizes } from '@ui/components/user/screens/LoginScreen/LoginLayout';
import { isRenewalProject } from '@shared/constants/projectTarget';

const LoginPage = () => {
  // 로그인 화면은 브라우저에서만 그려서 캐릭터 요청이 JS를 다 받은 뒤에야 시작된다. 서버 HTML에 미리 받기를 넣어 JS와 함께 받는다.
  if (isRenewalProject()) {
    preload(heroImages.study.src, {
      as: 'image',
      imageSrcSet: heroImages.study.srcSet,
      imageSizes: heroSizes,
      fetchPriority: 'high',
    });
  }

  return (
    <NoSsr>
      <LoginScreen />
    </NoSsr>
  );
};

export default LoginPage;
